import clsx from 'clsx';

/**
 * Der Schriftzug des Spiels, freigestellt.
 *
 * Zwei Anmerkungen:
 *  - Das Bild bringt Schatten und Schein bereits mit. Es gehört deshalb auf
 *    einen dunklen Grund; auf heller Fläche steht es in einer grauen Wolke.
 *  - WebP mit PNG-Rückfall: Die freigestellte Fassung braucht Transparenz, also
 *    kein JPEG. Das PNG wiegt rund 480 kB, das WebP rund 130 kB bei gleichem
 *    Eindruck – geladen wird in aller Regel nur das WebP.
 */
export function BrandLogo({ className, priority }: { className?: string; priority?: boolean }) {
  return (
    <picture>
      <source srcSet="/hosting-simulator-logo.webp" type="image/webp" />
      <img
        src="/hosting-simulator-logo.png"
        alt="Hosting Company Simulator"
        width={760}
        height={497}
        loading={priority ? 'eager' : 'lazy'}
        decoding="async"
        className={clsx('h-auto w-full object-contain', className)}
      />
    </picture>
  );
}
